import React, { useState } from 'react';
import { Users, PenSquare, Save, X } from 'lucide-react';
import { actualizarMatricula } from '../../services/matriculaService';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const DesarrolloSocialAfectivo = ({ matricula }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    juega_con_otros: matricula.desarrolloSocioAfectivo?.juega_con_otros || '',
    tiempo_celular_tv: matricula.desarrolloSocioAfectivo?.tiempo_celular_tv || '',
    relacion_ninos: matricula.desarrolloSocioAfectivo?.relacion_ninos || '',
    relacion_adultos: matricula.desarrolloSocioAfectivo?.relacion_adultos || '',
    afectuoso: matricula.desarrolloSocioAfectivo?.afectuoso || '',
    independiente: matricula.desarrolloSocioAfectivo?.independiente || '',
    sigue_instrucciones: matricula.desarrolloSocioAfectivo?.sigue_instrucciones || '',
    organiza_objetos: matricula.desarrolloSocioAfectivo?.organiza_objetos || '',
    actividades_agradables_dibujar: matricula.desarrolloSocioAfectivo?.actividades_agradables_dibujar || '',
    actividades_agradables_cantar: matricula.desarrolloSocioAfectivo?.actividades_agradables_cantar || '',
    actividades_agradables_escuchar_musica: matricula.desarrolloSocioAfectivo?.actividades_agradables_escuchar_musica || '',
    actividades_agradables_mirar_tv: matricula.desarrolloSocioAfectivo?.actividades_agradables_mirar_tv || '',
    actividades_agradables_ir_al_cine: matricula.desarrolloSocioAfectivo?.actividades_agradables_ir_al_cine || '',
    actividades_agradables_escuchar_cuentos: matricula.desarrolloSocioAfectivo?.actividades_agradables_escuchar_cuentos || '',
    actividades_agradables_realizar_deportes: matricula.desarrolloSocioAfectivo?.actividades_agradables_realizar_deportes || '',
    actividades_agradables_video_infantiles: matricula.desarrolloSocioAfectivo?.actividades_agradables_video_infantiles || '',
    pasatiempos: matricula.desarrolloSocioAfectivo?.pasatiempos || '',
    dificultad_relaciones: matricula.desarrolloSocioAfectivo?.dificultad_relaciones || false,
    dificultad_relaciones_detalle: matricula.desarrolloSocioAfectivo?.dificultad_relaciones_detalle || '',
    programas_favoritos: matricula.desarrolloSocioAfectivo?.programas_favoritos || '',
    personalidad: matricula.desarrolloSocioAfectivo?.personalidad || ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async () => {
    try {
      await actualizarMatricula(matricula.nino.id_child, {
        desarrolloSocioAfectivo: formData
      });

      setIsEditing(false);
      matricula.desarrolloSocioAfectivo = formData;
      toast.success('Desarrollo socio-afectivo actualizado exitosamente', {
        position: 'top-right',
        autoClose: 3000,
        style: { marginTop: '10px' }
      });
    } catch (error) {
      console.error('Error al actualizar:', error);
      toast.error('Error al actualizar los datos: ' + error.message, {
        position: 'top-right',
        autoClose: 3000,
        style: { marginTop: '10px' }
      });
    }
  };

  const inputStyle = "w-full px-2 py-1 text-sm bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500";
  const selectStyle = "w-full px-2 py-1 text-sm bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500";

  return (
    <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 relative">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-medium text-gray-900 flex items-center">
          <Users className="mr-2 text-indigo-500" size={20} />
          Desarrollo Socio-Afectivo
        </h3>
        {!isEditing ? (
          <PenSquare 
            className="text-indigo-500 cursor-pointer hover:text-indigo-600" 
            size={20} 
            onClick={() => setIsEditing(true)}
          />
        ) : (
          <div className="flex gap-2">
            <Save 
              className="text-green-500 cursor-pointer hover:text-green-600" 
              size={20} 
              onClick={handleSubmit}
            />
            <X 
              className="text-red-500 cursor-pointer hover:text-red-600" 
              size={20} 
              onClick={() => setIsEditing(false)}
            />
          </div>
        )}
      </div>

      <div className="grid grid-cols-1 gap-6">
        <div className="space-y-4">
          <div>
            <span className="text-sm font-medium text-gray-500 block mb-2">Hábitos:</span>
            <div className=" rounded-lg p-4">
              <table className="min-w-full divide-y divide-gray-200 border border-gray-200">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-500">Aspecto</th>
                    {isEditing ? (
                      <th className="px-4 py-2 text-center text-xs font-medium text-gray-500">Selección</th>
                    ) : (
                      <>
                        <th className="px-4 py-2 text-center text-xs font-medium text-gray-500">S</th>
                        <th className="px-4 py-2 text-center text-xs font-medium text-gray-500">AV</th>
                        <th className="px-4 py-2 text-center text-xs font-medium text-gray-500">RV</th>
                        <th className="px-4 py-2 text-center text-xs font-medium text-gray-500">N</th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {[
                    { label: 'Juega con hermanos u otros amigos', name: 'juega_con_otros' },
                    { label: 'Pasa mucho tiempo en el celular, o tv', name: 'tiempo_celular_tv' },
                    { label: 'Se relaciona fácilmente con otros niños', name: 'relacion_ninos' },
                    { label: 'Se relaciona fácilmente con otros adultos', name: 'relacion_adultos' },
                    { label: 'Es afectuoso', name: 'afectuoso' },
                    { label: 'Es independiente', name: 'independiente' },
                    { label: 'Sigue instrucciones', name: 'sigue_instrucciones' },
                    { label: 'Acostumbra a guardar sus objetos personales', name: 'organiza_objetos' }
                  ].map((item) => (
                    <tr key={item.name} className="hover:bg-gray-50">
                      <td className="px-4 py-2 text-sm text-gray-900">{item.label}</td>
                      {isEditing ? (
                        <td className="px-4 py-2">
                          <select
                            name={item.name}
                            value={formData[item.name]}
                            onChange={handleInputChange}
                            className={selectStyle}
                          >
                            <option value="">Seleccione...</option>
                            <option value="S">Siempre</option>
                            <option value="AV">A veces</option>
                            <option value="RV">Rara vez</option>
                            <option value="N">Nunca</option>
                          </select>
                        </td>
                      ) : (
                        <>
                          <td className="px-4 py-2 text-center">{formData[item.name] === 'S' ? '✓' : ''}</td>
                          <td className="px-4 py-2 text-center">{formData[item.name] === 'AV' ? '✓' : ''}</td>
                          <td className="px-4 py-2 text-center">{formData[item.name] === 'RV' ? '✓' : ''}</td>
                          <td className="px-4 py-2 text-center">{formData[item.name] === 'N' ? '✓' : ''}</td>
                        </>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div>
            <span className="text-sm font-medium text-gray-500 block mb-2">Actividades agradables:</span>
            <div className="  rounded-lg p-4">
              <table className="min-w-full divide-y divide-gray-200 border border-gray-200">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-500">Actividad</th>
                    {isEditing ? (
                      <th className="px-4 py-2 text-center text-xs font-medium text-gray-500">Selección</th>
                    ) : (
                      <>
                        <th className="px-4 py-2 text-center text-xs font-medium text-gray-500">SI</th>
                        <th className="px-4 py-2 text-center text-xs font-medium text-gray-500">NO</th>
                        <th className="px-4 py-2 text-center text-xs font-medium text-gray-500">A VECES</th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {[
                    { label: 'Dibujar', name: 'actividades_agradables_dibujar' },
                    { label: 'Cantar', name: 'actividades_agradables_cantar' },
                    { label: 'Escuchar música', name: 'actividades_agradables_escuchar_musica' },
                    { label: 'Mirar TV', name: 'actividades_agradables_mirar_tv' },
                    { label: 'Ir al cine', name: 'actividades_agradables_ir_al_cine' },
                    { label: 'Escuchar cuentos', name: 'actividades_agradables_escuchar_cuentos' },
                    { label: 'Realizar deportes', name: 'actividades_agradables_realizar_deportes' },
                    { label: 'Video infantiles', name: 'actividades_agradables_video_infantiles' }
                  ].map((item) => (
                    <tr key={item.name} className="hover:bg-gray-50">
                      <td className="px-4 py-2 text-sm text-gray-900">{item.label}</td>
                      {isEditing ? (
                        <td className="px-4 py-2">
                          <select
                            name={item.name}
                            value={formData[item.name]}
                            onChange={handleInputChange}
                            className={selectStyle}
                          >
                            <option value="">Seleccione...</option>
                            <option value="SI">Si</option>
                            <option value="NO">No</option>
                            <option value="AV">A veces</option>
                          </select>
                        </td>
                      ) : (
                        <>
                          <td className="px-4 py-2 text-center">{formData[item.name] === 'SI' ? '✓' : ''}</td>
                          <td className="px-4 py-2 text-center">{formData[item.name] === 'NO' ? '✓' : ''}</td>
                          <td className="px-4 py-2 text-center">{formData[item.name] === 'AV' ? '✓' : ''}</td>
                        </>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <span className="text-sm font-medium text-gray-500 block mb-2">Pasatiempos:</span>
              {isEditing ? (
                <textarea
                  name="pasatiempos"
                  value={formData.pasatiempos}
                  onChange={handleInputChange}
                  className={inputStyle}
                  rows="2"
                  placeholder="Describa los pasatiempos"
                />
              ) : (
                <p className="text-gray-900 text-sm">{formData.pasatiempos || 'Ninguno'}</p>
              )}
            </div>

            <div>
              <span className="text-sm font-medium text-gray-500 block mb-2">Dificultad en relaciones:</span>
              {isEditing ? (
                <div className="space-y-2">
                  <select
                    name="dificultad_relaciones"
                    value={formData.dificultad_relaciones}
                    onChange={(e) => setFormData(prev => ({
                      ...prev,
                      dificultad_relaciones: e.target.value === 'true'
                    }))}
                    className={selectStyle}
                  >
                    <option value={false}>No</option>
                    <option value={true}>Sí</option>
                  </select>
                  {formData.dificultad_relaciones && (
                    <textarea
                      name="dificultad_relaciones_detalle"
                      value={formData.dificultad_relaciones_detalle}
                      onChange={handleInputChange}
                      className={inputStyle}
                      rows="2"
                      placeholder="Describa las dificultades"
                    />
                  )}
                </div>
              ) : (
                <p className="text-gray-900 text-sm">
                  {formData.dificultad_relaciones ? 
                    formData.dificultad_relaciones_detalle : 
                    'Ninguna'}
                </p>
              )}
            </div>

            <div>
              <span className="text-sm font-medium text-gray-500 block mb-2">Programas favoritos:</span>
              {isEditing ? (
                <textarea
                  name="programas_favoritos"
                  value={formData.programas_favoritos}
                  onChange={handleInputChange}
                  className={inputStyle}
                  rows="2"
                  placeholder="Liste los programas favoritos"
                />
              ) : (
                <p className="text-gray-900 text-sm">{formData.programas_favoritos || 'Ninguno'}</p>
              )}
            </div>

            <div>
              <span className="text-sm font-medium text-gray-500 block mb-2">Personalidad:</span>
              {isEditing ? (
                <textarea
                  name="personalidad"
                  value={formData.personalidad}
                  onChange={handleInputChange}
                  className={inputStyle}
                  rows="2"
                  placeholder="Describa la personalidad"
                />
              ) : (
                <p className="text-gray-900 text-sm">{formData.personalidad || 'No especificada'}</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DesarrolloSocialAfectivo;
